import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

const axios = require('axios');
const apiUrl = '/wp-json/wp/v2/';
const apiACF = '/wp-json/acf/v3/';
let app;
const apiWCP = new WooCommerceRestApi({
  url: "https://inmondo.pl",
  consumerKey: 'ck_a1da091eeca455592b89bf49cdb0bac551be15d0',
  consumerSecret: "cs_348495b71f066cd76a996a7b7e16545c423b7c3b",
  version: "wc/v3"
});
const arrowRight = '<i class="fas fa-long-arrow-alt-right"></i>';
const arrowLeft = '<i class="fas fa-long-arrow-alt-left"></i>';
const closeIcon = '<i class="fas fa-times"></i>';
let menuMobileWrapper = document.getElementById('menuMobileWrapper');
let menuMoblieBox = document.querySelector('.headerMobile__navMenuWrapper');
// console.log(menuMobileWrapper);

//asynchroniczny forEach ;)
async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}
const clearWrapper = async () => {
  menuMobileWrapper.innerHTML = '';
}

class State {
	constructor() {
		this._data;
		this._depthLevel = 0;
		this._parentKey = 0;
		this._parentKeyLevel_1 = 0;
		this._parentID;
		this._parentName;
		this._parentSlug;

	}

	setData(data) {
		this._data = data;
	}

	getData() {
		return this._data;
	}

	setDepthLevel(level) {
		this._depthLevel = level;
	}

	getDepthLevel() {
		return this._depthLevel;
	}

	setParentKey(parent) {
		this._parentKey = parent;
	}

	getParentKey() {
		return this._parentKey;
	}

	setParentKeyLevel_1(parent) {
		this._parentKeyLevel_1 = parent;
	}

	getParentKeyLevel_1() {
		return this._parentKeyLevel_1;
	}

	setParentID(id) {
		this._parentID = id;
	}
	getParentID() {
		return this._parentID;
	}
	setParentSlug(slug) {
		this._parentSlug = slug;
	}
	getParentSlug() {
		return this._parentSlug;
	}
	setParentName(name) {
		this._parentName = name;
	}
	getParentName() {
		return this._parentName;
	}

}

const createMainMenu = async () => {
	await clearWrapper();
	const mainMenu = await app.getData();
	let list;
	
	const runEvents = async () => {
		const arrowLinks = await document.querySelectorAll('.menuMobile__arrowBox');
		asyncForEach(arrowLinks, async arrow => {
			await arrow.addEventListener('click', () => goDepther(arrow));
		})

		const closeLinks = await document.querySelectorAll('.menuMobile__close');
		asyncForEach(closeLinks, async arrow => {
			await arrow.addEventListener('click', () => {
				menuMoblieBox.classList.remove('open');
				document.body.style.overflowY = "auto"
			});
		})
	}

	const run = async () => {
		list = await document.createElement('ul');
		list.classList.add('menuMobile');

		const listItem = await document.createElement('li');
		listItem.classList.add('menuMobile__close');
		listItem.innerHTML = closeIcon + ' Zamknij';
		await list.appendChild(listItem);

		await asyncForEach(mainMenu, async (element, index) => {
			console.log(element);
			const listItem = await document.createElement('li');
			listItem.classList.add('menuMobile__item');

				const listLink = await document.createElement('a');
				console.log(element.link.post_name);
				listLink.href = await window.location.origin + "/" + element.link.post_name;
				listLink.setAttribute("data-index", index);
				listLink.setAttribute("data-parent", (element.title) ? element.title : element.link.post_name);

				(element.title) ? listLink.innerText = await element.title : listLink.innerText = await element.link.post_name;
				await listItem.appendChild(listLink);

				if(element.has_submenu) {
					const arrowBox = await document.createElement('span');
					arrowBox.classList.add('menuMobile__arrowBox');
					arrowBox.innerHTML = arrowRight;
					await listItem.appendChild(arrowBox);
				}
			await list.appendChild(listItem);
		});
		await menuMobileWrapper.appendChild(list);
	}
	await run();
	await runEvents();
}

const createMenuLevel_1 = async () => {
	await clearWrapper();
	let list;
	
	const runEvents = async () => {
		const arrowLinks = await document.querySelectorAll('.menuMobileLevel_1__arrowBox');
		asyncForEach(arrowLinks, async arrow => {
			
			await arrow.addEventListener('click', () => {
				const parent = arrow.parentElement;
				const link = parent.querySelector('a');
				app.setParentID(link.getAttribute('data-catParentID'));
				app.setParentSlug(link.getAttribute('data-catParentSlug'));
				app.setParentName(link.getAttribute('data-parent'));

				goDeptherLevel_1(arrow)
			});
		});

		const arrowReturn = await document.querySelectorAll('.menuMobile__closeCat');
		asyncForEach(arrowReturn, async arrow => {
			await arrow.addEventListener('click', () => createMainMenu());
		});
	}

	const run = async () => {
		list = await document.createElement('ul');
		list.classList.add('menuMobileLevel_1');
		let listItem;
		listItem = await document.createElement('li');
		listItem.classList.add('menuMobile__header');
		listItem.innerHTML = 'Produkty';
		await list.appendChild(listItem);

		listItem = await document.createElement('li');
		listItem.classList.add('menuMobile__closeCat');
		listItem.innerHTML = arrowLeft + ' wróć';
		await list.appendChild(listItem);

		await apiWCP.get("products/categories/", {
			parent: 0,
			exclude: [15, 33],
			orderby: 'id',
			order: 'asc'
		})
					.then((response) => {
						asyncForEach(response.data, async (item) => {
							listItem = document.createElement('li');
							listItem.classList.add('menuMobileLevel_1__item');
							const listLink = document.createElement('a');
							listLink.href = '/sklep/' + item.slug;
							listLink.setAttribute("data-catID", item.id);
							listLink.setAttribute("data-catParentID", item.id);
							listLink.setAttribute("data-catParentSlug", item.slug);
							listLink.setAttribute("data-parent", item.name);

							listLink.innerText = item.name;
							await listItem.appendChild(listLink);
							const arrowBox = document.createElement('span');
							arrowBox.classList.add('menuMobileLevel_1__arrowBox');
							arrowBox.innerHTML = arrowRight;
							listItem.appendChild(arrowBox);
							await list.appendChild(listItem);
						})
					})
					.catch((error) => {
					
					})
					.finally(() => {
						// Always executed.
					});
		await menuMobileWrapper.appendChild(list);
	}
	await run();
	await runEvents();
}

const createMenuLevel_2 = async (attribute2, attribute3, attribute4) => {
	await clearWrapper();
	let list;
	
	const runEvents = async () => {
		const returnLink = await document.querySelectorAll('.menuMobile__closeCat2');
		asyncForEach(returnLink, async link => {
			await link.addEventListener('click', () => goDepther());
		})

	}

	const run = async () => {
		list = await document.createElement('ul');
		list.classList.add('menuMobileLevel_2');
		let listItem;

		listItem = await document.createElement('li');
		listItem.classList.add('menuMobile__header');
		listItem.innerHTML = attribute4;
		await list.appendChild(listItem);

		listItem = await document.createElement('li');
		listItem.classList.add('menuMobile__closeCat2');
		listItem.innerHTML = arrowLeft + ' wróć';
		await list.appendChild(listItem);

				await apiWCP.get("products/categories/", {
					parent: attribute2,
					orderby: 'id',
					order: 'asc'
				})
					.then((response) => {
						asyncForEach(response.data, async (item, index) => {
							listItem = document.createElement('li');
							listItem.classList.add('menuMobileLevel_2__item');
							const listLink = document.createElement('a');
							listLink.href = '/sklep/'+ attribute3 + '/' + item.slug;
							listLink.innerText = item.name;
							listItem.appendChild(listLink);
							list.appendChild(listItem);
						})
					})
					.catch((error) => {
						// Invalid request, for 4xx and 5xx statuses
						console.log("Response Status:", error.response.status);
						console.log("Response Headers:", error.response.headers);
						console.log("Response Data:", error.response.data);
					})
					.finally(() => {
						// Always executed.
					});
			

			// })
		// }
		await menuMobileWrapper.appendChild(list);
	}
	await run();
	await runEvents();
}

const goDepther = async element => {
	// const parent = element.parentElement;
	// const link = parent.querySelector('a');
	// const attribute = link.getAttribute('data-index');
	// const attribute2 = link.getAttribute('data-parent')


	// await clearWrapper();
	// await createMenuLevel_1(attribute, attribute2);
	await createMenuLevel_1();
}

const goDeptherLevel_1 = async element => {
	const parent = element.parentElement;
	const link = parent.querySelector('a');
	// const attribute = link.getAttribute('data-catID');
	const attribute2 = app.getParentID();
	const attribute3 = app.getParentSlug();
	const attribute4 = app.getParentName();
	
	// const attribute2 = link.getAttribute('data-catParentID');
	// const attribute3 = link.getAttribute('data-catParentSlug');
	// const attribute4 = link.getAttribute('data-parent');

	// await clearWrapper();
	await createMenuLevel_2(attribute2, attribute3, attribute4);
}

const getMenuJson = async () => {
	await axios.get(apiACF + 'options/menu-main')
	
	.then((response) => {
		console.log(response);
		app.setData(response.data.acf.main_menu.menu_repeater);
	})
	.catch(function (error) {
		// handle error
		console.log(error);
	})
}
// if(document.querySelector('.headerMobile__navBarSearch--button')){
	const searchButton = document.querySelector('.headerMobile__navBarSearch--button')
	const searchForm = document.querySelector('.headerMobile__navBarSearch form')
	const menuBox = document.querySelector('.headerMobile')
	searchButton.addEventListener('click', e => menuBox.classList.add('search'))
	window.onload = function(){
		document.onclick = function(e){
			if(e.target.parentNode !== searchButton && e.target !== searchForm && e.target.parentNode !== searchForm && e.target.parentNode !== searchForm.querySelector('button[type=submit]')) menuBox.classList.remove('search')
		}
	}
// }

export const menuMobileInit = async () => {
	app = new State();
	await getMenuJson();
	await createMainMenu();

	const hamburger = document.querySelector('.c-hamburger');

	hamburger.addEventListener('click', async ()=>{
		// await createMainMenu();
		menuMoblieBox.classList.add('open');
		document.body.style.overflowY = "hidden"
	})
}
